import { getUIDirection, Locale } from '@fluidx/utilities';
import { ComponentsIconsType, ComponentsIconNames, FFXHostUxIconsType, FluidPreviewAppIconsType } from './iconSets';
import { componentsIconLocalizationMap } from './localization';

/**
 * A type-safe way to access the icon names that are within this icon set , without registering the icons
 *
 * @param name property name of componentsIcons
 */
export const componentsIconName = (name: ComponentsIconsType, locale?: Locale): ComponentsIconNames => {
  const iconLocalizationInfo = componentsIconLocalizationMap[name];
  if (locale === undefined || iconLocalizationInfo === undefined) {
    return name;
  }

  const localeDirection = getUIDirection(locale);

  // Validate UI language to see if icon has an rtl Icon and we should render that one instead.
  if (localeDirection === 'rtl' && iconLocalizationInfo.rtlIconName) {
    return iconLocalizationInfo.rtlIconName;
  }

  // Check locale from locale list
  if (iconLocalizationInfo.localizedIconNames && iconLocalizationInfo.localizedIconNames[locale] !== undefined) {
    return iconLocalizationInfo.localizedIconNames[locale] ?? name;
  }

  return name;
};

/**
 * A type-safe way to access the icon names that are within this icon set, without registering the icons
 *
 * @param name property name of ffxHostUxIcons icons
 */
export const ffxHostUxIconName = (name: FFXHostUxIconsType) => name;

/**
 * A type-safe way to access the icon names that are within this icon set, without registering the icons
 *
 * @param name property name of fluidPreviewAppIcons
 */
export const fluidPreviewAppIconName = (name: FluidPreviewAppIconsType) => name;
